import { keyframes } from '@emotion/react';
import { Box, Card, Grid, HStack, Stack } from 'components/ui';

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

interface SkeletonProps {
  height: string;
  width?: string;
  mb?: number;
}

const SkeletonLine: React.FC<SkeletonProps> = ({ height, width = '100%', mb = 2 }) => (
  <Box
    height={height}
    width={width}
    bg={{ base: 'gray.200', _dark: 'gray.700' }}
    borderRadius="md"
    mb={mb}
    css={{
      animation: `${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite`
    }}
  />
);

interface ListSkeletonProps {
  count?: number;
  showMiddleColumn?: boolean;
}

export const ListSkeleton: React.FC<ListSkeletonProps> = ({ count = 5, showMiddleColumn = false }) => {
  return (
    <Stack gap={3} w="full" maxW="full">
      {Array.from({ length: count }).map((_, index) => (
        <Card.Root key={index} overflow="hidden" w="full" maxW="full">
          <Card.Body p={4}>
            <Grid 
              templateColumns={showMiddleColumn ? { base: '1fr', md: '2fr 1fr 1fr' } : { base: '1fr', md: '2fr 1fr' }} 
              gap={4} 
              w="full" 
              maxW="full"
            >
              {/* Left column - Info */}
              <Stack gap={2}>
                <SkeletonLine height="20px" width="70%" />
                <SkeletonLine height="16px" width="90%" />
                <SkeletonLine height="16px" width="85%" />
              </Stack>

              {/* Middle column - Details (optional) */}
              {showMiddleColumn && (
                <HStack gap={2} justify="flex-start">
                  <SkeletonLine height="24px" width="60px" />
                  <SkeletonLine height="24px" width="60px" />
                </HStack>
              )}

              {/* Right column - Actions */}
              <HStack gap={2} justify="flex-end">
                <SkeletonLine height="36px" width="36px" />
                <SkeletonLine height="36px" width="36px" />
              </HStack>
            </Grid>
          </Card.Body>
        </Card.Root>
      ))}
    </Stack>
  );
};
